// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"
import "./activity_analytics"

import { initFlowbite } from "flowbite"

Turbo.config.forms.confirm = (message) => {
  const dialog = document.querySelector("#action-confirmation")
  if (!dialog || dialog.open) return Promise.resolve(false)
  dialog.querySelector("[data-confirmation-message]").textContent = message
  return new Promise((resolve) => {
    const finish = (confirmed) => {
      dialog.removeEventListener("click", choose)
      dialog.removeEventListener("cancel", cancel)
      dialog.removeEventListener("close", closed)
      dialog.removeEventListener("keydown", containFocus)
      dialog.close()
      resolve(confirmed)
    }
    const choose = (event) => {
      const choice = event.target.closest("[data-confirmation-choice]")?.dataset.confirmationChoice
      if (choice) finish(choice === "confirm")
    }
    const cancel = (event) => { event.preventDefault(); finish(false) }
    const closed = () => finish(false)
    const containFocus = (event) => {
      if (event.key !== "Tab") return
      const choices = [...dialog.querySelectorAll("button:not([disabled]), a[href], input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex='0']")]
      const first = choices[0]
      const last = choices[choices.length - 1]
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last?.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first?.focus()
      }
    }
    dialog.addEventListener("click", choose)
    dialog.addEventListener("cancel", cancel)
    dialog.addEventListener("close", closed)
    dialog.addEventListener("keydown", containFocus)
    dialog.showModal()
    dialog.querySelector("[data-confirmation-choice='cancel']").focus()
  })
}

let newPageVisit = false

document.addEventListener("turbo:before-visit", (event) => {
  const destination = new URL(event.detail.url)
  newPageVisit = destination.pathname !== window.location.pathname && !destination.hash
})

document.addEventListener("turbo:visit", (event) => {
  if (event.detail.action === "restore") newPageVisit = false
})

document.addEventListener("turbo:load", () => {
  if (!newPageVisit) return
  newPageVisit = false
  window.requestAnimationFrame(() => {
    const heading = document.querySelector("main h1")
    heading?.setAttribute("tabindex", "-1")
    heading?.focus({ preventScroll: true })
    window.scrollTo({ top: 0, behavior: "instant" })
  })
})

document.addEventListener("turbo:load", () => initFlowbite())
document.addEventListener("turbo:frame-load", () => initFlowbite())
document.addEventListener("turbo:render", () => initFlowbite())
